import { render, staticRenderFns } from "./UserRegisterReport.vue?vue&type=template&id=008490ce"
import script from "./UserRegisterReport.vue?vue&type=script&lang=js"
export * from "./UserRegisterReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports